'use strict';

angular.module('app').directive('hideElement', function() {

    var link = function(scope) {
        $(scope.hideElement).hide();

        $('.js-header-mobile li:not(".account-item")').hide();
    };

    return {
        restrict: 'A',
        scope: {
            hideElement: '@'
        },
        link: link
    };
});